"use strict";

import 'babel-polyfill';

import ReactDOM from 'react-dom';
import React from 'react';
import { StaticConfigLoader } from 'components/setup/staticConfigsLoader';
import { AuthenticationProcessor } from 'components/authentication';
import { MarketConfigLoader } from 'components/app';
import {  getStartPath,  getStartArgs  } from  'generics/queryArgs.js';
import {  processArgsAndRoutes  } from  'generics/routed.js';



////////////////////////////////////////////////////////////////////////////////////////////////////
// kickstarta

document.addEventListener('DOMContentLoaded', () => {

  console.info( "getStartPath", getStartPath() );
  console.info( "getStartArgs", getStartArgs() );
  processArgsAndRoutes();

  ReactDOM.render(
    <StaticConfigLoader>{
      (staticConfigs) =>  <AuthenticationProcessor {...staticConfigs} >{
                            (authStatus) => <MarketConfigLoader  {...staticConfigs} {...authStatus} />
                          }</AuthenticationProcessor>
    }</StaticConfigLoader>,
    document.getElementById('appRoot')
  );

});
